// extracted by mini-css-extract-plugin
module.exports = {"title":"Alert_title__2kS02","message":"Alert_message__2rvdq","btns":"Alert_btns__2xLmY","button":"Alert_button__2h2GH","link":"Alert_link__aia29"};